// extracted by mini-css-extract-plugin
var _1 = "TeammateStatusLabel-module__muted--HU2ju";
var _2 = "TeammateStatusLabel-module__success--Qtm2Q";
var _3 = "TeammateStatusLabel-module__warning--JwJrB";
export { _1 as "muted", _2 as "success", _3 as "warning" }
